import React from "react";
import { Link, withRouter } from "react-router-dom";
import clockTime from "../../../assets/icons/clock.svg";
import {
  getDateAndTime,
  objectHasKeysCheck,
} from "../../../services/commonMethods";
import { viewRefillPlanUrl } from "../../../constants/appRoutes";

function NotificationContainer(props) {
  const { data, showTime } = props;
  const getTitle = (data) => {
    switch (data.type) {
      case "HARDWARE_BOARD_ONBOARD":
        return {
          title: "Hardware Board",
          subtitle: "Hardware Board Server configured",
        };
        // case "REFILL_EXECUTE":
        return {
          title: (
            <Link
              to={viewRefillPlanUrl.call(
                {
                  store_id: data.store_id,
                  warehouse_id: data.warehouse_id,
                  vmId: data.vending_machine_id,
                },
                data.refill_id
              )}
            >
              {data.VendingMachineRefill?.name}
            </Link>
          ),
          subtitle: "Refill executed",
        };

      case "REFILL_EXECUTE":
        return {
          title: (
            <Link
              to={viewRefillPlanUrl.call(
                {
                  store_id: data.store_id,
                  warehouse_id: data.warehouse_id,
                  vmId: data.vending_machine_id,
                },
                data.refill_id
              )}
            >
              {data.VendingMachineRefill?.name}
            </Link>
          ),
          subtitle: "Refill Executed",
        };

      case "REFILL_PLAN_CREATED_BY_REFILL_PARTNER":
        return {
          title: !data.ReturnOrder ? (
            <Link
              to={viewRefillPlanUrl.call(
                {
                  store_id: data.store_id,
                  warehouse_id: data.warehouse_id,
                  vmId: data.vending_machine_id,
                },
                data.refill_id
              )}
            >
              {data.VendingMachineRefill?.refill_id}
            </Link>
          ) : (
            <Link to={`return-order-view/${data.ReturnOrder.id}`}>
              {data.ReturnOrder.return_order_id}
            </Link>
          ),

          subtitle: !data.ReturnOrder
            ? "Refill Plane Created"
            : "Return Order Created",
        };
      case "LOW_INVENTORY_WAREHOUSE":
        return {
          title: (
            <Link
              to={`/warehouse-inventory/${data.Warehouse.id}`}
            >{`${data.Product.name}`}</Link>
          ),

          subtitle: "",
        };
      case "REFILL_PLAN_DELETED_BY_REFILL_PARTNER":
        return {
          title: !data.ReturnOrder ? (
            <Link
              to={viewRefillPlanUrl.call(
                {
                  store_id: data.store_id,
                  warehouse_id: data.warehouse_id,
                  vmId: data.vending_machine_id,
                },
                data.refill_id
              )}
            >
              {data.VendingMachineRefill?.refill_id}
            </Link>
          ) : (
            <Link to={`return-order-view/${data.ReturnOrder.id}`}>
              {data.ReturnOrder.return_order_id}
            </Link>
          ),

          subtitle: !data.ReturnOrder
            ? "Refill Plane Deleted"
            : "Return Order Deleted",
        };

      case "ABOUT_TO_RUNOUT":
        return {
          title: (
            <Link to={`/product/${data.Product.id}`}>{data.Product.name}</Link>
          ),
          subtitle: "About to run out",
        };
      case "OUT_OF_STOCK":
        return {
          title: (
            <Link to={`/product/${data.Product.id}`}>{data.Product.name}</Link>
          ),
          subtitle: "Out of stock",
        };
      case "PRODUCT_REQUEST":
        return {
          title: <Link to={`/products-requested`}>{data.product_name}</Link>,
          subtitle: "Product requested",
        };
      case "PRODUCT_EXPIRED":
        return {
          title: (
            <div>
              {data.items_expired} items of {data.Product.name}
            </div>
          ),
          subtitle: "Product expired",
        };
      case "VEND_FAILURE":
        return {
          title: <Link to={`/order/${data.cart_id}`}>{data.order_id}</Link>,
          subtitle: "Vend Failure",
        };
      case "PARTIAL_VEND_FAILURE":
        return {
          title: <Link to={`/order/${data.cart_id}`}>{data.order_id}</Link>,
          subtitle: "Partial Vend Failure",
        };
      case "PAYMENT_TIMEDOUT":
        return {
          title: <Link to={`/order/${data.cart_id}`}>{data.order_id}</Link>,
          subtitle: "Payment timed out",
        };
      case "VM_STATUS":
        return {
          title: (
            <Link to={`/vm/${data.VendingMachine?.id}`}>
              {/* {data.VendingMachine.name} */}
            </Link>
          ),
          subtitle: "Vending machine status changed",
        };

      case "VM_MOTOR":
        return {
          title: (
            <Link to={`/vm/${data.VendingMachine?.id}`}>
              {/* {data.VendingMachine.name} */}
            </Link>
          ),
          subtitle: `Vending machine Motor ${data.motor_status}`,
        };
      case "VM_MOTOR_FIXED":
        return {
          title: (
            <Link to={`/vm/${data.VendingMachine?.id}`}>
              {/* {data.VendingMachine.name} */}
            </Link>
          ),
          subtitle: "Vending machine Motor Fixed",
        };
      case "MANUAL_REFUND":
        return {
          title: <Link to={`/order/${data.cart_id}`}>{data.order_id}</Link>,
          subtitle: "Manually initiated refund",
        };
      case "AUTO_REFUND":
        return {
          title: <Link to={`/order/${data.cart_id}`}>{data.order_id}</Link>,
          subtitle: "Auto initiated refund",
        };
      case "CANCELLED_BY_CONSUMER":
        return {
          title: <Link to={`/order/${data.cart_id}`}>{data.order_id}</Link>,
          subtitle: "Cancelled by consumer",
        };
      case "VEND_SUCCESS":
        return {
          title: <Link to={`/order/${data.cart_id}`}>{data.order_id}</Link>,
          subtitle: "Vend success",
        };
      case "DISCOUNT_EXPIRED":
        return {
          title: (
            <Link to={`/discount-view/${data.Discount.id}`}>
              {data.Discount.name}
            </Link>
          ),
          subtitle: "Discount Expired",
        };
      case "TRANSACTION_REPORT_RESPONSE":
        return {
          title: <Link to={`/orders`}>Transaction Report</Link>,
          subtitle: "Sent",
        };
      case "DROP_SENSOR_FAILED":
        return {
          title: (
            <Link to={`/vm/${data.VendingMachine.id}`}>
              {data.VendingMachine.name}
            </Link>
          ),
          subtitle: "Vending machine drop sensor failed",
        };
      case "MOTOR_FAILED":
        return {
          title: (
            <Link to={`/vm/${data.VendingMachine.id}`}>
              {data.VendingMachine.name}
            </Link>
          ),
          subtitle: "Vending machine motor failed",
        };
      // case "REFILL_PARTNER_CASH_COLLECTED":
      //   return {
      //     title: (
      //       <Link to={`/vm/${data.VendingMachine.id}`}>
      //         Cash Collected{data.VendingMachine.name}
      //       </Link>
      //     ),
      //     subtitle: "",
      //   };
      default:
        return { title: "", subtitle: "" };
    }
  };

  const getMsg = (data) => {
    switch (data.type) {
      case "REFILL_EXECUTE":
        if (objectHasKeysCheck(data.Manager)) {
          return (
            <p>
              by Manager{" "}
              {
                <Link to={`/user/${data.Manager.id}`}>
                  {data.Manager.first_name + " " + data.Manager.last_name}
                </Link>
              }{" "}
              for{" "}
              {
                <Link to={`/vm/${data.VendingMachine.id}`}>
                  {data.VendingMachine.name}
                </Link>
              }
              .
            </p>
          );
        } else if (objectHasKeysCheck(data.DeliveryPerson)) {
          return (
            <p>
              by Delivery Person{" "}
              {
                <Link to={`/user/${data.DeliveryPerson.id}`}>
                  {data.DeliveryPerson.name}
                </Link>
              }{" "}
              for{" "}
              {
                <Link to={`/vm/${data.VendingMachine.id}`}>
                  {data.VendingMachine.name}
                </Link>
              }{" "}
              Vending Machine.
            </p>
          );
        }
        return "";
      case "ABOUT_TO_RUNOUT":
      case "OUT_OF_STOCK":
      case "PRODUCT_REQUEST":
      case "PRODUCT_EXPIRED":
        return (
          <p>
            are expired in
            {
              <Link to={`/vm/${data.VendingMachine?.id}`}>
                {data.VendingMachine?.name}
              </Link>
            }
            vending machine,
            {
              <Link
                to={`add-refill-plan?vmId=${data.VendingMachine?.id}&${
                  data.store_id
                    ? "storeId=" + data.store_id
                    : "warehouseId=" + data.warehouse_id
                }`}
              >
                Generate a refill plan
              </Link>
            }{" "}
            to remove those items on Vending Machine .
          </p>
        );
      case "VEND_FAILURE":
        return (
          <p>
            {<Link to={`/order/${data.order_db_id}`}>{data.order_id}</Link>}{" "}
            (Vend failure) All items didn’t vend successfully on vending machine
            {
              <Link to={`/vm/${data.VendingMachine?.id}`}>
                {data.VendingMachine?.name}
              </Link>
            }
            , check the overview page to take an action against the respective
            motors All items didn't vend on Vending Machine .
          </p>
        );
      case "HARDWARE_BOARD_ONBOARD":
        return (
          <p>
            Hardware Board &nbsp;&nbsp;
            {<Link to={`/vm`}>{data.hardware_board_name}</Link>}, server has
            been configured.
          </p>
        );
      case "PARTIAL_VEND_FAILURE":
        return (
          <p>
            {<Link to={`/order/${data.order_db_id}`}>{data.order_id}</Link>}{" "}
            (Partial Vend failure) Few items didn’t vend successfully on vending
            machine
            {
              <Link to={`/vm/${data.VendingMachine?.id}`}>
                {data.VendingMachine?.name}
              </Link>
            }
            , check the overview page to take an action against the respective
            motors All items didn't vend on Vending Machine .
          </p>
        );
      case "PAYMENT_TIMEDOUT":
        return (
          <p>
            for the above order on Vending Machine{" "}
            {
              <Link to={`/vm/${data.VendingMachine?.id}`}>
                {data.VendingMachine?.name}
              </Link>
            }
            .
          </p>
        );
      case "VM_STATUS":
        return (
          <p>
            Vending Machine{" "}
            {
              <Link to={`/vm/${data.VendingMachine?.id}`}>
                {data.VendingMachine?.name}
              </Link>
            }{" "}
            status changed to{" "}
            {data.vm_is_active ? " Active" : " Under Maintenance"}
          </p>
        );
      case "VM_MOTOR":
        return (
          <p>
            Vending Machine{" "}
            {
              <Link to={`/vm/${data.VendingMachine?.id}`}>
                {data.VendingMachine?.name}
              </Link>
            }{" "}
            {`motor of cell ${data.cell} has been ${data.motor_status}`}
          </p>
        );
      case "VM_MOTOR_FIXED":
        return (
          <p>
            Vending Machine{" "}
            {
              <Link to={`/vm/${data.VendingMachine?.id}`}>
                {data.VendingMachine?.name}
              </Link>
            }{" "}
            {`Motor of cell ${data.cell} has been ${data.motor_status} unblock the cell ${data.cell}`}
          </p>
        );
      case "REFILL_PLAN_CREATED_BY_REFILL_PARTNER":
        return (
          <p>
            {!data.ReturnOrder ? "Refill Plan" : "Return Order"}{" "}
            {!data.ReturnOrder ? (
              <Link
                to={viewRefillPlanUrl.call(
                  {
                    store_id: data.store_id,
                    warehouse_id: data.VendingMachine.warehouse_id,
                    vmId: data.VendingMachine.id,
                  },
                  data.refill_id
                )}
              >
                {data.VendingMachineRefill?.refill_id}
              </Link>
            ) : (
              <Link to={`return-order-view/${data.ReturnOrder.id}`}>
                {data.ReturnOrder.return_order_id}
              </Link>
            )}{" "}
            has been Created for {data.VendingMachine.name} <br />
            {!data.ReturnOrder ? (
              <Link
                to={viewRefillPlanUrl.call(
                  {
                    store_id: data.store_id,
                    warehouse_id: data.VendingMachine.warehouse_id,
                    vmId: data.VendingMachine.id,
                  },
                  data.refill_id
                )}
              >
                See Details
              </Link>
            ) : (
              <Link to={`return-order-view/${data.ReturnOrder.id}`}>
                See Details
              </Link>
            )}
            {/* {data.created_by} */}
          </p>
        );
      case "REFILL_PLAN_DELETED_BY_REFILL_PARTNER":
        return (
          <p>
            Refill Plane{" "}
            {!data.ReturnOrder ? (
              <Link
                to={viewRefillPlanUrl.call(
                  {
                    store_id: data.store_id,
                    warehouse_id: data.VendingMachine.warehouse_id,
                    vmId: data.VendingMachine.id,
                  },
                  data.refill_id
                )}
              >
                {data.VendingMachineRefill?.refill_id}
              </Link>
            ) : (
              <Link to={`return-order-view/${data.ReturnOrder.id}`}>
                {data.ReturnOrder.return_order_id}
              </Link>
            )}{" "}
            has been Deleted for {data.VendingMachine.name}
          </p>
        );
      case "LOW_INVENTORY_WAREHOUSE":
        return (
          <p>
            {data.Product.name} Present in the warehouse {data.Warehouse.name}{" "}
            is about to finish {data.Warehouse.id}
            <br />
            {
              <Link to={`/warehouse-inventory/${data.Warehouse.id}`}>
                See Details
              </Link>
            }
          </p>
        );
      case "MANUAL_REFUND":
        return (
          <p>
            of amount &#8377;&nbsp;{data.refund_amount} by Manager{" "}
            {
              <Link to={`/user/${data.Manager.id}`}>
                {data.Manager.first_name + " " + data.Manager.last_name}
              </Link>
            }
          </p>
        );
      case "AUTO_REFUND":
        return <p>of amount &#8377;&nbsp;{data.refund_amount}.</p>;
      case "CANCELLED_BY_CONSUMER":
        return <p>above order canceled by the consumer.</p>;
      case "VEND_SUCCESS":
        return (
          <p>
            above order vended successfully from{" "}
            {
              <Link to={`/vm/${data.VendingMachine.id}`}>
                {data.VendingMachine.name}
              </Link>
            }
            .
          </p>
        );
      case "DISCOUNT_EXPIRED":
        return <p>Expired on: {getDateAndTime(data.Discount.end_date)}.</p>;
      case "TRANSACTION_REPORT_RESPONSE":
        return (
          <p>
            Transaction Report has been successfully sent on your registered
            email id.
          </p>
        );

      case "DROP_SENSOR_FAILED":
        return (
          <p>
            Vending Machine
            {
              <Link to={`/vm/${data.VendingMachine.id}`}>
                {data.VendingMachine.name}
              </Link>
            }
            drop sensor has failed.
            {
              <Link to={`/vm?vmEventId=${data.VendingMachine.id}`}>
                Check Events{" "}
              </Link>
            }
            for more information.
          </p>
        );
      case "MOTOR_FAILED":
        return (
          <p>
            Vending Machine
            {
              <Link to={`/vm/${data.VendingMachine.id}`}>
                {data.VendingMachine.name}
              </Link>
            }
            motor has stopped working, check
            {<Link to={`/vm/${data.VendingMachine.id}`}>overview page</Link>}
            for suitable actions.
          </p>
        );
      // case "REFILL_PARTNER_CASH_COLLECTED":
      //   return (
      //     <p>
      //       {data.VendingMachine.name}, cash collected by refill partner{" "}
      //       {data.RefillPartner.name} <br />
      //       {<Link to={`/view-cash-order/${data.id}`}>See Details</Link>}
      //     </p>
      //   );
      default:
        return ``;
    }
  };
  return (
    <div className="notification-content-box">
      <span className="notification-indicator color-1" />
      <div className="notification-heading">
        <h1>
          {getTitle(data).title}{" "}
          <small>
            {getTitle(data).subtitle && `(${getTitle(data).subtitle})`}
          </small>
        </h1>
        {showTime ? (
          <p>
            <img src={clockTime} alt="Notification Time Image" />{" "}
            {getDateAndTime(data.created_at)}
          </p>
        ) : (
          ""
        )}
      </div>
      <div className="notification-body">{getMsg(data)}</div>
    </div>
  );
}

export default withRouter(NotificationContainer);
